


























import { Component } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { ContextsState } from '@/store';
import DataSource from 'devextreme/data/data_source';
import { Table, TableOptions, getTableCaption } from '@/core/components/table';
import { Page } from '@/core/components/controls';
import { DxDataGrid } from 'devextreme-vue/data-grid';
import {
    CONTRACTS,
    EventsServiceContract,
    Events,
    AuthServiceContract,
    WindowsServiceContract,
    FetchServiceContract,
} from '@/core/contracts';
import { LocationHistoryRecord, Site } from '@/dto';
import LocationHistoryTable from './LocationHistoryTable.vue';
import config from '@/config';
import { GroupedLocationHistory } from './types';
import { IContext } from '@/api';
import ODataStore from 'devextreme/data/odata/store';

@Component({
    components: {
        DxDataGrid,
        LocationHistoryTable,
        TableOptions,
    },
})
export default class LocationHistoryPage extends Page {
    private table: Table | null = null;
    private tableKey: string = 'location-history-control';
    private filter: any = ['ContextId', '=', ContextsState.currentContextId];
    private sites: Site[] = [];

    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;
    @Inject(CONTRACTS.AuthService)
    private _authService?: AuthServiceContract;
    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    public setTable(table: Table): void {
        this.table = table;
    }

    public async mounted() {
        const currentContextId = ContextsState.currentContextId;
        const sitesUrl = `/files/contexts/${currentContextId}/Sites`;
        const sitesData = await this._fetchService!.get<IContext>(sitesUrl);
        this.sites = sitesData.sites as Site[];

        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public get dataSource(): DataSource {
        const result = new DataSource({
            key: 'id' as keyof LocationHistoryRecord,
            store: new ODataStore({
                url: `${config.remoteHost}/api/v2/odata/LocationHistory`,
                version: 4,
                withCredentials: true,
                beforeSend: (e: any) => {
                    e.headers = {
                        Authorization: `Bearer ${
                            this._authService!.accessToken
                        }`,
                    };
                },
            }),
            filter: this.filter,
            expand: ['Vehicle', 'Placement'],
            sort: [{ getter: 'NavTime', desc: true }],
            select: [
                'Id',
                'NavTime',
                'Longitude',
                'Latitude',
                'Vehicle.Name',
                'Placement.Name',
                'Distance',
            ],
        });
        return result;
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    private onProcessingFinished({ contextId }: any) {
        if (Number(ContextsState.currentContextId) === Number(contextId)) {
            this.table!.refresh();
        }
    }

    private showLocationHistoryMap() {
        const filter = this.table!.getCombinedFilter();
        this.dataSource
            .store()
            .load({
                filter,
                group: 'Vehicle.Name',
                sort: [{ getter: 'NavTime', desc: true }],
                select: ['NavTime', 'Longitude', 'Latitude'],
                expand: 'Vehicle',
            })
            .done((items: GroupedLocationHistory[]) => {
                this._windowsService!.open('location-history-map', {
                    locationHistory: items,
                    sites: this.sites,
                });
            });
    }
}
